import { Box, Breadcrumbs, Button, Chip, FormControl, InputAdornment, InputLabel, MenuItem, Paper, Select, Stack, TextField, Typography, useMediaQuery } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import Main from "../components/Main";
import { Link } from "react-router-dom";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import SearchIcon from '@mui/icons-material/Search';
import UsersTable from "../components/tables/UsersTable";
import SideMenu from "../components/SideMenu";
import AppNavBar from "../components/AppNavBar";
import AppBottomNavigation from "../components/AppBottomNavigation";
import UserFormDialog from "../components/dialogs/UserFormDialog";
import { AuthContext } from "../utils/AuthContext";
import { deleteUser, exportUsers, fetchUsers } from "../services/UsersService";
import AlertDialog from "../components/AlertDialog";
import CheckIcon from '@mui/icons-material/Check';
import { toast } from "react-toastify";
import ResetPasswordDialog from "../components/dialogs/ResetPasswordDialog";
import { useTheme } from "@emotion/react";
import moment from "moment";
import getHomeLink from "../utils/getHomeLink";

const Users = () => {
    const [open, setOpen] = useState(localStorage.getItem('drawer-open') == 'true');

    const theme = useTheme();
    const isMediumScreen = useMediaQuery(theme.breakpoints.up("md"));

    const [searchQuery, setSearchQuery] = useState();
    const [filterBy, setFilterBy] = useState('full_name')

    const [rows, setRows] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const [openUserFormDialog, setOpenUserFormDialog] = useState(false);
    const [userFormMode, setUserFormMode] = useState('create');
    const [selectedUser, setSelectedUser] = useState(null);

    const [userType, setUserType] = useState('Agent');

    const [openResetPasswordFormDialog, setOpenResetPasswordFormDialog] = useState(false);

    const [showDeleteDialog, setShowDeleteDialog] = useState(false);

    const { auth } = useContext(AuthContext);

    const [isExporting, setIsExporting] = useState(false);


    useEffect(() => {
        handleFetchUsers();
    }, []);

    // useEffect(() => {
    //     handleFetchUsers(userType);
    //     console.log('page, rowsPerPage');
    // }, [page, rowsPerPage]);

    useEffect(() => {
        if (searchQuery === undefined) {
            return;
        }

        const delayDebounceFn = setTimeout(() => {
            handleFetchUsers();
        }, 1500);

        return () => clearTimeout(delayDebounceFn);
    }, [searchQuery]);

    // useEffect(() => {
    //     if (searchQuery.trim() === '') {
    //         return;
    //     }

    //     handleFetchUsers();

    //     console.log('filterBy');

    // }, [filterBy]);

    const toggleDrawer = () => {
        localStorage.setItem('drawer-open', !open);
        setOpen(!open);
    };

    function handleClick(event) {
        event.preventDefault();
        console.info('You clicked a breadcrumb.');
    }

    async function handleFetchUsers(data) {

        setIsLoading(true);
        fetchUsers({
            filterBy: data?._filter_by || filterBy,
            token: auth.token,
            searchQuery: data?._search_query || searchQuery,
            page: (data?._page || page) + 1,
            pageSize: data?._rows_per_page || rowsPerPage,
            userType: data?._user_type || userType
        }).then(res => {
            setRows(res.data.users);
            setTotalRecords(res.data.total);
            setIsLoading(false);
        }).catch(error => {
            console.error("Error fetching clients:", error);
            setIsLoading(false);
        });
    }

    function handleDeleteUser() {
        deleteUser({ token: auth.token, userId: selectedUser.id })
            .then(() => {
                toast.success("User has been deleted.", {
                    autoClose: 2000,
                    hideProgressBar: true,
                    icon: ({ theme, type }) => <CheckIcon sx={{ color: '#3328BF' }} />,
                    closeButton: false
                });

                handleFetchUsers();
            })
            .catch(() => {
                // error
                toast.error("The user cannot be deleted.", {
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false
                });
            });
    }

    const breadcrumbs = [
        <Link sx={{ textDecoration: 0 }} key="1" color="inherit" to={getHomeLink(auth)}>
            Home
        </Link>,
        // <Link
        //     underline="hover"
        //     key="2"
        //     color="inherit"
        //     href="/material-ui/getting-started/installation/"
        //     onClick={handleClick}
        // >
        //     Core
        // </Link>,
        <Typography key="2" sx={{ color: 'text.primary' }}>
            Users
        </Typography>,
    ];

    const handleClickAdd = () => {
        setOpenUserFormDialog(true);
        setUserFormMode('create');
        setSelectedUser(null);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);

        handleFetchUsers({ _page: newPage });
    };

    const handleChangeRowsPerPage = (event) => {
        const value = parseInt(event.target.value, 10);
        setRowsPerPage(value);
        setPage(0);

        handleFetchUsers({ _rows_per_page: value });
    };

    function handleSearch(e) {
        const delayDebounceFn = setTimeout(() => {
            handleFetchUsers({ _search_query: e.target.value });

            console.log('delayDebounceFn');
        }, 1000);

        return () => clearTimeout(delayDebounceFn);
    }
    const handleExportUsers = async () => {

        try {
            const token = auth.token;
            const filters = {
                filterBy,
                searchQuery,
            };

            setIsExporting(true)
            // Show loading toast without auto-closing
            const loadingToastId = toast.info("Exporting users...", { autoClose: false });
            const blob = await exportUsers({ token, filters });
            setIsExporting(false)

            // Close loading toast
            toast.dismiss(loadingToastId);

            // Show success toast with 2-second duration
            toast.success("Users exported!", { autoClose: 2500 });


            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = "Users_Export_" + moment().format('YYYY_MM_DD') + ".csv";
            document.body.appendChild(a);
            a.click();
            a.remove();
        } catch (error) {
            // Handle error
            console.error('Error exporting users:', error);
        }
    };

    return (
        <Box sx={{
            backgroundColor: '#ededed',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden', // Ensure no vertical scrollbar
        }}>
            {/* <MainHeader open={open} setOpen={setOpen} /> */}

            <AppNavBar currentPage='users' />
            <Box sx={{ display: 'flex', flexGrow: 1, overflow: 'hidden' }}>


                <SideMenu currentPage='users' />

                <Main open={open}
                    sx={{
                        // height: '100%',
                        overflow: 'hidden',
                        marginLeft: {
                            xs: 0,
                            md: 1
                        },
                        backgroundColor: '#fff',
                        mt: 7,
                        mb: 2,
                        marginRight: {
                            xs: 0,
                            md: 1
                        },
                        borderRadius: {
                            xs: 0,
                            md: 2
                        },
                        flexGrow: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        px: {
                            xs: 2,
                            md: 3
                        },
                        py: 2
                    }} >

                    <Box sx={{
                        display: 'flex', flexDirection: 'row', justifyContent: 'space-between', mb: {
                            xs: 2,
                            md: 1
                        }, alignItems: 'start'
                    }}>
                        <Box>
                            <Typography variant="h1" sx={{ fontSize: 24 }}>
                                Users
                            </Typography>

                            <Stack sx={{
                                display: {
                                    xs: 'none',
                                    md: 'block'
                                }
                            }} spacing={2}>
                                <Breadcrumbs
                                    separator={<NavigateNextIcon fontSize="small" />}
                                    aria-label="breadcrumb"
                                >
                                    {breadcrumbs}
                                </Breadcrumbs>
                            </Stack>
                        </Box>

                        <Button onClick={handleClickAdd} variant="contained">
                            Add User
                        </Button>
                    </Box>

                    <Box sx={{
                        width: '100%', mb: '15px', display: 'flex', flexDirection: 'row', justifyContent: {
                            xs: 'left',
                            md: 'right'
                        },
                        gap: 2,
                        mt: {
                            xs: 1,
                            md: 0
                        }
                    }}>


                        <TextField fullWidth={!isMediumScreen} type="search" className="search" sx={{ mt: 1, ml: 1 }} size='small' variant='standard' placeholder="Search..." InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            )
                        }}
                            value={searchQuery}
                            onChange={(e) => {
                                setSearchQuery(e.target.value);

                                // handleSearch(e);
                            }}
                        />

                        <Box>
                            <FormControl size="small" variant="outlined">
                                <InputLabel id="filter-by-select-label">Filter By</InputLabel>
                                <Select
                                    labelId="filter-by-select-label"
                                    id="filter-by-select"
                                    label="Filter By"
                                    value={filterBy}
                                    onChange={(e) => {
                                        setFilterBy(e.target.value);

                                        handleFetchUsers({ _filter_by: e.target.value });
                                    }}

                                >
                                    <MenuItem value="full_name">Name</MenuItem>
                                    {
                                        userType === 'Agent' && <MenuItem value="agent_id">Agent ID</MenuItem>
                                    }
                                    <MenuItem value="email">Email</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                        <Button sx={{
                            display: {
                                xs: 'none',
                                md: 'block'
                            }
                        }} variant="contained" disabled={isExporting} onClick={handleExportUsers}>Export</Button>
                    </Box>
                    <Box>
                        <Chip
                            label="Agents"
                            onClick={() => {
                                setUserType('Agent');

                                handleFetchUsers({ _user_type: 'Agent' });
                            }}
                            color={userType === 'Agent' ? 'primary' : 'default'}
                            disabled={isLoading}
                        />
                        <Chip
                            label="Admins"
                            onClick={() => {
                                setUserType('Admin');

                                handleFetchUsers({ _user_type: 'Admin' });
                            }}
                            sx={{ ml: 1 }}
                            color={userType === 'Admin' ? 'primary' : 'default'}
                            disabled={isLoading}
                        />
                    </Box>

                    <UsersTable
                        users={rows}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        totalRecords={totalRecords}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        isLoading={isLoading}
                        setSelectedUser={setSelectedUser}
                        setOpenUserFormDialog={setOpenUserFormDialog}
                        setUserFormMode={setUserFormMode}
                        setShowDeleteDialog={setShowDeleteDialog}
                        setOpenResetPasswordFormDialog={setOpenResetPasswordFormDialog}
                        userType={userType}
                    />

                    {/* Bottom Navigation */}
                    <Paper sx={{
                        zIndex: 9997,
                        display: {
                            xs: 'block',
                            md: 'none'
                        }, position: 'fixed', bottom: 0, left: 0, right: 0
                    }} elevation={3}>
                        <AppBottomNavigation currentPage="users" />
                    </Paper>


                    <UserFormDialog
                        dialogOpen={openUserFormDialog}
                        setDialogOpen={setOpenUserFormDialog}
                        callback={() => {
                            handleFetchUsers();
                        }}
                        mode={userFormMode}
                        selectedUser={selectedUser}
                        userType={userType}
                        setUserType={setUserType}
                    />

                    <ResetPasswordDialog
                        dialogOpen={openResetPasswordFormDialog}
                        setDialogOpen={setOpenResetPasswordFormDialog}
                        selectedUser={selectedUser} />
                    {
                        selectedUser &&
                        <AlertDialog
                            open={showDeleteDialog}
                            setOpen={setShowDeleteDialog}
                            title={"Do you want to delete " + selectedUser.full_name + "?"}
                            content="Please confirm by clicking the delete button"
                            positiveButtonLabel="Delete"
                            negativeButtonLabel="Cancel"
                            callback={() => {
                                setShowDeleteDialog(false);
                                handleDeleteUser();
                            }}
                        />
                    }

                </Main >

            </Box >
        </Box>
    );
}

export default Users